import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import { customPalette } from "./theme";

const footerTheme = createTheme({
  palette: customPalette,
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontSize: "2rem",
      color: customPalette.primary.main,
    },
    h2: {
      fontSize: "1.75rem",
      color: customPalette.primary.main,
    },
    h3: {
      fontSize: "1.5rem",
    },
    h4: {
      fontSize: "1.25rem",
    },
    h5: {
      fontSize: "1.1rem",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: customPalette.primary.contrastText,
          "&.Mui-disabled": {
            color: customPalette.grey[600],
          },
        },
        outlinedPrimary: {
          color: customPalette.primary.main,
        },
      },
    },
  },
});

export const theme = responsiveFontSizes(footerTheme);
